<mat-form-field class="example-full-width" appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <input matInput [formControl]="control" [matAutocomplete]="auto" [placeholder]="label" />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayProperty"
    (optionSelected)="onSelect($event)"
  >
    <mat-option *ngFor="let warehouse of filteredOptions | async | async" [value]="warehouse">
      {{ warehouse.description }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

<!-- <mat-form-field appearance="outline">
    <mat-label>Склад</mat-label>
    <mat-select [formControl]="control">
      <mat-option *ngFor="let warehouse of warehouses | async" value="warehouse.description">{{warehouse.description}}</mat-option>
    </mat-select>
  </mat-form-field> -->
